import { firebaseRemoteConfig } from '@src/config';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { useAppStore } from '@src/shared/zustand/store';
import { REMOTE_CONFIG_FLAGS } from './remote-config.constants';

export const setRemoteConfigData = (data: Record<string, any>) =>
  useAppStore.setState({ remoteConfigData: data });

/**
 * Carrega AUTOMATICAMENTE todos os valores do Firebase Remote Config
 * Não precisa adicionar manualmente cada flag aqui!
 *
 * As flags são definidas em REMOTE_CONFIG_FLAGS (remote-config.constants.ts)
 *
 * Para adicionar nova flag:
 * 1. Adicione em REMOTE_CONFIG_FLAGS
 * 2. Crie a flag no Firebase Console
 * 3. Pronto! getRemoteConfigData() carregará automaticamente
 */
export const getRemoteConfigData = async (
  callback: (error: Error | null) => void
) => {
  try {
    await fetchAndActivate(firebaseRemoteConfig);

    // Carrega automaticamente TODAS as flags definidas em REMOTE_CONFIG_FLAGS
    const configData: Record<string, any> = {};

    Object.values(REMOTE_CONFIG_FLAGS).forEach((flagName) => {
      try {
        const value = getValue(firebaseRemoteConfig, flagName);
        try {
          configData[flagName] = JSON.parse(value.asString());
        } catch {
          configData[flagName] = value.asString();
        }
      } catch {
        console.warn(`Flag "${flagName}" não encontrada no Remote Config`);
        configData[flagName] = null;
      }
    });

    setRemoteConfigData(configData);
    callback(null);
  } catch (error) {
    setRemoteConfigData({});
    callback(error instanceof Error ? error : new Error(String(error)));
  }
};
